export const FREE = 'free';
export const PAID = 'paid';
